import { Model } from './Model';

type ModelClass = { new (...args: any): Model };
type RelationKey<P> = P extends { new (...args: any): infer T } ? keyof T : string;

export interface Relationship<P extends ModelClass, M extends ModelClass = any> {
    key: RelationKey<P>;
    model: M;
    parent: P;
    collection: boolean;
}

export interface Relations<P extends Model> {
    relations(): Relationship<{ new (): P }>[];
}

/**
 * Create a relationship that's holding a model
 * @param key
 * @param model
 * @param parent
 * @constructor
 */
export function HasOne<P extends ModelClass, M extends ModelClass>(
    key: RelationKey<P>,
    model: M,
    parent: P,
): Relationship<P, M> {
    return {
        key,
        model,
        parent,
        collection: false,
    };
}

/**
 * Create a relationship that's holding an array of models
 * @param key
 * @param model
 * @param parent
 * @constructor
 */
export function HasMany<P extends ModelClass, M extends ModelClass>(
    key: RelationKey<P>,
    model: M,
    parent: P,
): Relationship<P, M> {
    return {
        ...HasOne(key, model, parent),
        collection: true,
    };
}
